import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
    return (
        <div className='home-container'>
            <h1 className='home-title'>Benvenuti in Settemotivi</h1>

            <p>
                Settemotivi – ODV racconta il territorio del Friuli Venezia Giulia attraverso la radio:
                volontariato, salute, storia locale e cultura, in onda su Radio Cosmo.
            </p>
            <p>
                Scopri chi siamo, i progetti che abbiamo realizzato e come puoi sostenerci.
            </p>

            <ul className='home-links'>
                <li><Link to='chisiamo'>Chi siamo</Link></li>
                <li><Link to='progetti'>I nostri progetti</Link></li>
                <li><Link to='donazioni'>Donazioni</Link></li>
            </ul>
        </div>
    );
}

export default Home;
